var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageappointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7728 0.84375C2.03425 0.84375 1.43555 1.44246 1.43555 2.181V13.8174C1.43555 14.8969 2.64869 15.5315 3.53545 14.9158L7.75043 11.9894C7.90038 11.8853 8.09923 11.8853 8.24917 11.9894L12.4642 14.9158C13.3509 15.5315 14.5641 14.8969 14.5641 13.8174V2.181C14.5641 1.44246 13.9654 0.84375 13.2268 0.84375H2.7728ZM13.5753 2.181V3.11499H2.42427V2.181C2.42427 1.98852 2.58031 1.83248 2.7728 1.83248H13.2268C13.4193 1.83248 13.5753 1.98852 13.5753 2.181ZM2.42427 4.10372H13.5753V13.8174C13.5753 14.0987 13.2592 14.2641 13.028 14.1036L8.81305 11.1772C8.32404 10.8377 7.67557 10.8377 7.18656 11.1772L2.97157 14.1036C2.74045 14.2641 2.42427 14.0987 2.42427 13.8174V4.10372Z",
    fill: "#389FE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageappointment);
export default __webpack_public_path__ + "static/media/Manage appointment.23d7e747cdcb2fd82b9aeb57355e390e.svg";
export { ForwardRef as ReactComponent };